import { format } from 'date-fns'

import { logFirebaseEvent } from '@/utils/firebase.utils'

const FIREBASE_DATE_FORMAT = 'dd/MM/yyyy - HH:mm:ss'

export const sendLoginDeniedEvent = (errorFlag: number, storeId?: string) => {
  if (!storeId) return

  switch (errorFlag) {
    case 0: {
      logFirebaseEvent('AC_Web_DeactivatedAccount', {
        Event_Time: format(new Date(), FIREBASE_DATE_FORMAT),
        Store_ID: storeId
      })
      break
    }
    case 2: {
      logFirebaseEvent('AC_Web_SuspendededAccount', {
        Event_Time: format(new Date(), FIREBASE_DATE_FORMAT),
        Store_ID: storeId
      })
      break
    }
    case 3: {
      logFirebaseEvent('AC_Web_InprogressAccount', {
        Event_Time: format(new Date(), FIREBASE_DATE_FORMAT),
        Store_ID: storeId
      })
      break
    }
  }
}
